// Undo/Redo V1 (Feb 2026) -- shared UI for the visible-grid undo
// stacks on Roster and Rota Style. Two small buttons plus the
// compare-and-warn confirmation dialog. Presentational only; all
// stack and write logic stays in the owning page.
import { Button } from "@/components/ui/button";
import { Undo2, Redo2 } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

export const UndoRedoButtons = ({ canUndo, canRedo, busy, onUndo, onRedo, testidPrefix }) => (
  <div className="flex items-center gap-1 bg-white border border-slate-200 rounded-lg px-1 py-1">
    <Button
      variant="ghost"
      size="sm"
      disabled={!canUndo || busy}
      onClick={onUndo}
      title="Undo last cell change"
      data-testid={`${testidPrefix}-undo-btn`}
    >
      <Undo2 className="h-4 w-4 mr-1" />Undo
    </Button>
    <Button
      variant="ghost"
      size="sm"
      disabled={!canRedo || busy}
      onClick={onRedo}
      title="Redo cell change"
      data-testid={`${testidPrefix}-redo-btn`}
    >
      <Redo2 className="h-4 w-4 mr-1" />Redo
    </Button>
  </div>
);

/** mode: null (closed) | "undo" | "redo". Shown when the cell changed
 *  since the recorded edit (concurrency compare-and-warn guard). */
export const UndoRedoConfirmDialog = ({ mode, onCancel, onProceed, testidPrefix }) => (
  <Dialog open={!!mode} onOpenChange={(o) => { if (!o) onCancel(); }}>
    <DialogContent className="max-w-sm" data-testid={`${testidPrefix}-undo-redo-confirm`}>
      <DialogHeader>
        <DialogTitle>{mode === "redo" ? "Redo this change?" : "Undo this change?"}</DialogTitle>
        <DialogDescription>
          {mode === "redo"
            ? "This cell has changed since your edit. Redo anyway?"
            : "This cell has changed since your edit. Undo anyway?"}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2">
        <Button
          variant="outline"
          onClick={onCancel}
          data-testid={`${testidPrefix}-undo-redo-cancel`}
        >
          Cancel
        </Button>
        <Button
          onClick={onProceed}
          data-testid={`${testidPrefix}-undo-redo-proceed`}
        >
          {mode === "redo" ? "Redo anyway" : "Undo anyway"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
